export const removeCountryName = (value: string) => value.replace(/(^Россия, )|(, Россия$)/i, '');
